import React, { Component } from "react";
import { capitalize } from "lodash";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import moment from "moment";
import Select from "react-select";

import "react-datepicker/dist/react-datepicker.css";
import metricDefinitions from "../../metricDefinitions";
import OutcomesSettingsModal from "../OutocomesSettings/OutcomesSettingsModal";
import SelectClient from "./SelectClient";

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      smallScreen: window.innerWidth < 1450,
      hidden: window.innerWidth < 1450,
      start_date: moment(props.start_date),
      end_date: moment(props.end_date),
      showSettings: false,
      showResidentFilter: window.innerWidth > 1450,
      organization_name: props.organization_name
    };
  }

  componentDidMount() {
    const {
      group_ids,
      group_categories,
      groups,
      start_date,
      end_date,
      resident_statuses,
    } = this.props;

    var selectedStatuses = [{ value: "All", label: "All" }];
    var selectedOption = [{ value: "", label: "All Facilities" }];
    if (resident_statuses) {
      selectedStatuses = [];
      resident_statuses.forEach((status) => {
        selectedStatuses.push({
          label: capitalize(status),
          value: status,
        });
      });
      if (selectedStatuses.length === 0)
        selectedStatuses = [{ value: "All", label: "All" }];
    }
    this.setState(() => {
      return { selectedStatuses };
    });

    if (group_ids || group_categories) {
      selectedOption = [];
      group_ids.forEach((g) => {
        const toAdd = groups.find((f) => f.id === g);
        selectedOption.push({
          label: toAdd.name,
          value: toAdd.id,
        });
      });
      group_categories.forEach((category) => {
        selectedOption.push({
          label: capitalize(category),
          value: category,
        });
      });
      if (selectedOption.length === 0)
        selectedOption = [{ value: "", label: "All Facilities" }];
    }
    this.setState(() => {
      return { selectedOption };
    });
  }

  toggleHidden() {
    this.setState(() => {
      return { hidden: !this.state.hidden };
    });
  }

  handleSearch() {
    const { selectedOption, selectedStatuses } = this.state;
    const { start_date, end_date } = this.props;
    const selectedGroups = selectedOption.filter(
      (e) => typeof e.value === "number" || e === ""
    );
    const selectedCategories = selectedOption.filter(
      (e) => typeof e.value === "string" && e !== ""
    );
    this.props.dispatch({
      type: "UPDATE_FILTERS",
      payload: {
        group_id: this.props.groups[0].id,
        group_ids: selectedGroups.map((o) => {
          return o.value;
        }),
        group_categories: selectedCategories.map((o) => {
          return o.value;
        }),
        resident_statuses: selectedStatuses.map((o) => {
          return o.value;
        }),
      },
    });
  }

  handleExportCSV(e) {
    e.preventDefault();
    const {
      start_date,
      end_date,
      organization_name,
      permissions,
      selectedSection,
    } = this.props;
    const { selectedOption, selectedStatuses } = this.state;
    const selectedGroups = selectedOption.filter(
      (e) => typeof e.value === "number" || e === ""
    );
    const selectedCategories = selectedOption.filter(
      (e) => typeof e.value === "string" && e !== ""
    );
    const group_ids = selectedGroups.map((o) => {
      return o.value;
    });
    const group_categories = selectedCategories.map((o) => {
      return o.value;
    });
    const resident_statuses = selectedStatuses.map((o) => {
      return o.value;
    });

    let endpoints = [];
    if (selectedSection.smallName === "surveys")
      endpoints = this.surveyMetrics();
    else
      endpoints = metricDefinitions(organization_name, permissions)[
        selectedSection.smallName
      ].metrics;
    endpoints = endpoints.filter((m) => m.visible).map((m) => m.endpoint);
    const url = `/organizations/${organization_name}/outcome_metrics/multi.csv?metrics=${endpoints.join(
      ","
    )}&start_date=${moment(start_date)}&end_date=${moment(
      end_date
    )}&group_ids=${String(group_ids)}&resident_statuses=${resident_statuses}`;
    window.location.href = url;
  }

  surveyMetrics = () => {
    const { permissions, organization_name } = this.props;
    return metricDefinitions(organization_name, permissions)[
      "surveys"
    ].percentChangeMetrics.concat(
      metricDefinitions(organization_name, permissions)[
        "surveys"
      ].percentChangePerMonthMetrics.concat(
        metricDefinitions(organization_name, permissions)[
          "surveys"
        ].exitSurveyMetrics.concat(
          metricDefinitions(organization_name, permissions)
            ["surveys"].dischargeSurveyMetrics.concat(
              metricDefinitions(organization_name, permissions)["surveys"]
                .transitionSurveyMetrics
            )
            .concat(
              metricDefinitions(organization_name, permissions)["surveys"]
                .averageScorePerMonthMetrics
            )
        )
      )
    );
  };

  setupOptions = () => {
    const { groups, group_id, all_group_categories } = this.props;
    let groupOptions = [{ value: "", label: "All Facilities" }];
    groups.map((group) => {
      groupOptions.push({
        value: group.id,
        label: group.name,
      });
    });
    let categoryOptions = [];
    all_group_categories.map((category) => {
      categoryOptions.push({
        value: category,
        label: capitalize(category),
      });
    });
    let options = [
      { label: "Facilities", options: groupOptions },
      { label: "Category", options: categoryOptions },
    ];
    return options;
  };

  setupResidentStatuses = () => {
    const { all_resident_statuses } = this.props;
    let options = [];
    all_resident_statuses.map((status) => {
      options.push({ value: status, label: status });
    });
    return options;
  };

  handleSelectChange = (selectedOption) => {
    this.setState(
      () => {
        if (selectedOption.length) {
          const lastOption = selectedOption[selectedOption.length - 1];
          if (lastOption.value === "") return { selectedOption: [lastOption] };
          else
            return {
              selectedOption: selectedOption.filter((o) => {
                return o.value != "";
              }),
            };
        } else {
          return { selectedOption };
        }
      },
      () => this.handleSearch()
    );
  };

  handleResidentStatusChange = (selectedOptions) => {
    this.setState(
      () => {
        if (selectedOptions.length) {
          const lastOption = selectedOptions[selectedOptions.length - 1];
          if (lastOption.value === "All")
            return { selectedStatuses: [lastOption] };
          else
            return {
              selectedStatuses: selectedOptions.filter((o) => {
                return o.value != "All";
              }),
            };
        } else {
          return { selectedStatuses: selectedOptions };
        }
      },
      () => this.handleSearch()
    );
  };

  render() {
    const {
      selectedOption,
      selectedStatuses,
      hidden,
      smallScreen,
      showResidentFilter,
    } = this.state;
    const { start_date, end_date, selectedSection, organization_name, permissions } = this.props;
    const { enabledFilters } = metricDefinitions(organization_name, permissions)[
      selectedSection.smallName
    ];

    return (
      <div className="w-100 mb-2 mr-1">
        <OutcomesSettingsModal
          show={this.state.showSettings}
          closeModal={() => {
            this.setState(() => {
              return { showSettings: false };
            });
          }}
        />
        {!hidden && (
          <div
            className="d-flex flex-column flex-sm-row w-100 justify-content-center h-100 p-3"
            id="search_bar"
          >
            <div className="mb-2 mr-sm-2">
              <DatePicker
                className="form-control datepicker-input"
                placeholderText="Start date"
                selected={moment(start_date)}
                isDisabled={!enabledFilters.includes("dates")}
                onChange={(date) => {
                  this.props.dispatch({
                    type: "UPDATE_DATES_FILTERS",
                    payload: {
                      start_date: moment(date).format("YYYY-MM-DD"),
                    },
                  });
                  this.handleSearch();
                }}
              />
            </div>
            <div className="mb-2 mr-sm-2">
              <DatePicker
                className="form-control datepicker-input"
                placeholderText="End date"
                selected={moment(end_date)}
                isDisabled={!enabledFilters.includes("dates")}
                onChange={(date) => {
                  this.props.dispatch({
                    type: "UPDATE_DATES_FILTERS",
                    payload: {
                      end_date: moment(date).format("YYYY-MM-DD"),
                    },
                  });
                  this.handleSearch();
                }}
              />
            </div>
            <div className="mb-2 mr-sm-2" style={{ minWidth: "250px" }}>
              <Select
                allowClear={false}
                value={selectedOption}
                onChange={(selectedOption) =>
                  this.handleSelectChange(selectedOption)
                }
                options={this.setupOptions()}
                isDisabled={!enabledFilters.includes("facilities")}
                isMulti={true}
              />
            </div>
            {enabledFilters.includes("categories") && (
              <div className="mb-2 mr-sm-2" style={{ minWidth: "250px" }}>
                <Select
                  allowClear={false}
                  value={selectedStatuses}
                  onChange={(selectedStatuses) =>
                    this.handleResidentStatusChange(selectedStatuses)
                  }
                  options={this.setupResidentStatuses()}
                  isDisabled={!enabledFilters.includes("categories")}
                  isMulti={true}
                />
              </div>
            )}

            {/* <button
              className="btn btn-info mb-2 ml-2"
              onClick={(e) => this.props.handlePrint()}
              style={styles.submitButton}
            >
              Export PDF
            </button> */}
            <button
              className="btn btn-info mb-2 ml-2"
              onClick={(e) => {
                this.setState(() => {
                  return { showSettings: true };
                });
              }}
              style={styles.submitButton}
            >
              Settings
            </button>
          </div>
        )}
        {showResidentFilter && (
          <SelectClient
            className="h-100 p-3 ml-3"
            residents={this.props.residents}
          />
        )}
        {smallScreen && (
          <a
            className="btn btn-sm btn-primary text-white float-right mb-1 mr-1"
            onClick={() => {
              this.setState(() => {
                return { showSettings: true };
              });
            }}
            style={styles.submitButton}
          >
            Settings
          </a>
        )}
        {smallScreen && (
          <a
            className="btn btn-sm btn-primary text-white float-right mb-1 mr-1"
            onClick={(e) => this.toggleHidden(e)}
            style={styles.submitButton}
          >
            {hidden ? "Filters" : "Hide"}
          </a>
        )}
        {smallScreen && (
          <a
            className="btn btn-sm btn-primary text-white float-right mb-1 mr-1"
            onClick={() => {
              this.setState(() => {
                return { showResidentFilter: !showResidentFilter };
              });
              this.props.dispatch({
                type: "UPDATE_FILTERS",
                payload: {
                  resident_id: null,
                },
              });
            }}
            style={styles.submitButton}
          >
            {showResidentFilter ? "Hide client filter" : "Filter by Client"}
          </a>
        )}
      </div>
    );
  }
}

const styles = {
  // dateInput:{
  //   width: '26.66%',
  // },
  // submitButton:{
  //   width: '20%',
  // }
};

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    residents: state.residents,
    organization_name: state.static.organization_name,
    permissions: state.static.permissions,
    selectedSection: state.selected,
    start_date: state.filters.start_date,
    end_date: state.filters.end_date,
  };
}

export default connect(mapStateToProps)(SearchBar);
